import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './outline-breadcrumb.global.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 *
 * The Outline Core Breadcrumb component
 *
 * @element outline-breadcrumb
 * @extends LitElement
 * @slot - default slot
 *
 */

@customElement('outline-breadcrumb')
export class OutlineCoreBreadcrumb extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    // We need no encapsulated styles for this component.
    // encapsulatedCSS: encapsulatedStyles,
  });

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-breadcrumb': OutlineCoreBreadcrumb;
  }
}
